import { Injectable } from '@angular/core';
import { CommandDefinition, CommandHelper, QuickCommandService } from '@app/shared/quick-commands';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ReloadLanguageCommand implements CommandDefinition<any> {
  icon = 'far fa-sync';
  label = 'quickCommands.commands.reloadLanguage';
  name = 'reloadLanguage';
  section = QuickCommandService.DevSection;

  constructor(private translateService: TranslateService) {}

  action() {
    this.translateService.reloadLang(this.translateService.currentLang);

    return CommandHelper.close();
  }
}
